import { useCallback, useState } from "react";

import OTATableComponent from "./ota-table.component";

import TableSort from "../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../shared/helpers/upper-case";
import OTAStatusTableComponent from "./ota.status.component";
import { useQuery } from "@tanstack/react-query";
import { getOTA } from "src/core/api/services/ota.service";

const renderOTAStatusModal = (data: any) => <OTAStatusTableComponent data={data} />;

const OTAComponent = () => {
  const [PageNumber, setPageNumber] = useState<number>(1);
  const pageSize = 10;
  const [otaSearchValue, setOtaSearchValue] = useState("");

  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("firmwareVersion"));
  const [SortDirection, setSortDirection] = useState<any>("desc");

  const [columns, setColumns] = useState([
    {
      title: "Firmware Version",
      label: "firmwareVersion",
      isSorted: true,
      // width: "9rem"
    },
    {
      title: "Supplier",
      label: "supplierName",
      // width: "9rem"
    },
    {
      title: "Uploaded By",
      label: "uploadBy",
      width: "9rem",
    },
    {
      title: "Upload Date",
      label: "uploadTimestamp",
      type: "datetime",
      width: "9rem",
    },
    {
      title: "Description",
      label: "description",
      textLength: 50,
    },
    {
      title: "Status",
      label: "status",
      excludeSort: true,
      renderProps: (data: any) => {
        const isZeroByZero =
          data?.ackcount === 0 && data?.totalDevice === 0;
        return (
          <div className={!isZeroByZero ? "link-color cursor-pointer" : ""}>
            {isZeroByZero ? "-" : `${data?.ackcount}/${data?.totalDevice}`}
          </div>
        );
      },
      headerTitle: "OTA Status",
      modalRenderProps: renderOTAStatusModal,
    },
  ]);

  const {
    data: otaData,
    isLoading: isLoadingOTA,
    refetch,
  } = useQuery({
    queryKey: ["getOTA", PageNumber, SortBy, SortDirection, otaSearchValue],
    queryFn: ({ signal }: any) =>
      getOTA(
        PageNumber,
        pageSize,
        SortBy,
        SortDirection,
        otaSearchValue,
        signal
      ),
  });

  const onRefetchData = () => {
    void refetch();
  };

  const handleChangePage = useCallback((page: number): void => {
    setPageNumber(page);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  const handleSearch = useCallback((searchVal: string): void => {
    setPageNumber(1);
    setOtaSearchValue(searchVal);
  }, []);

  return (
    <div>
      <OTATableComponent
        columns={columns}
        data={otaData?.data}
        totalNumberOfRecords={otaData?.numberOfRecords}
        pageSize={pageSize}
        current={PageNumber}
        onChangePage={handleChangePage}
        onRefetchData={onRefetchData}
        onChangeSort={handleChangeSort}
        onSearch={handleSearch}
        isLoadingOTA={isLoadingOTA}
      />
    </div>
  );
};

export default OTAComponent;
